import { render, staticRenderFns } from "./TaskMemberList.vue?vue&type=template&id=2d89d016&"
import script from "./TaskMemberList.vue?vue&type=script&lang=js&"
export * from "./TaskMemberList.vue?vue&type=script&lang=js&"
import style0 from "./TaskMemberList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports